export const Role = {
  Admin: 'ROLE_ADMIN',
  Reviewer: 'ROLE_REVIEWER',
  User: 'ROLE_USER',
}
